import styles from 'styles/modules/popUps/ActionConfirm.module.scss';
import Avatar from 'components/Svg/Avatar.js';
import Button from 'components/Button';

const ActionConfirm = ({ expertToRemove, onRemove, onCancel }) => {
    if (!expertToRemove) return null;

    const handleConfirm = () => {
        if (onRemove) {
            onRemove();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    const avatar = expertToRemove.imageUrl ? (
        <div
            className={styles.avatar}
            style={{ backgroundImage: `url(${expertToRemove.imageUrl})` }}
        />
    ) : (
        <Avatar />
    );

    return (
        <div className={styles.wrapper}>
            {expertToRemove && (
                <div className={styles.popUp}>
                    <h4 className={styles.title}>
                        Are you sure you want to delete
                        <br />
                        {expertToRemove.name} from your NewsPage?
                    </h4>
                    <div className={styles.expert}>
                        <div className={styles.image}>{avatar}</div>
                        <div className={styles.titlesWrapper}>
                            <div className={styles.name}>
                                {expertToRemove.name}
                            </div>
                            <div className={styles.position}>
                                {expertToRemove.position}
                            </div>
                        </div>
                    </div>
                    <div className={styles.buttonWrapper}>
                        <Button
                            title={'Cancel'}
                            onClick={handleCancel}
                            classes={[styles.cancelButton]}
                        />
                        <Button
                            title={'Confirm'}
                            onClick={handleConfirm}
                            classes={[styles.confirmButton]}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionConfirm;
